(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main', [
      'ui.router',
      'itecAdministracio.entitats.main.llista',
      'itecAdministracio.entitats.main.dades',
      'itecAdministracio.entitats.main.formulari',
      'itecAdministracio.entitats.main.administradors',
      'itecAdministracio.entitats.main.llicencies',
      'itecAdministracio.entitats.main.sessions',
      'itecAdministracio.entitats.main.logos'
    ]);
}());
